// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dimple-lowcode-form-item .el-textarea__inner{font-size:.781vw!important;resize:none}.dimple-lowcode-form-item .el-range-input{font-size:.729vw!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
